import React from "react";
import Arabic1Shedule from "./Arabic1Shedule";
import Arabic2Schedule from "./Arabic2Schedule";

const Schedule = () => {
  return (
    <div className="container mx-auto my-16">
      <Arabic1Shedule></Arabic1Shedule>
      <Arabic2Schedule></Arabic2Schedule>
    </div>
  );
};

export default Schedule;
